<div class="mb-3">
  <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
    <ng-select [formControl]="formControlObj" [items]="optionsObs | async" bindLabel="value" bindValue="key"
      [multiple]="true" [placeholder]="isOptionLoading ? 'Loading..' : 'Select Option'">
    </ng-select>
  </app-field-title>
</div>